import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  makeStyles,
  Typography,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { useState, useEffect } from "react";
import DialogTitle from "../../../components/SFDialogTitle";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useTranslate } from "react-admin";
import useUsers from "../../../hooks/useUsers";
// import { usePopup } from "react-hook-popup";
// import SimplePopupDialog from "../../../components/SimplePopupDialog";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: 400,
    height: 300,
    margin: "0 auto",
    paddingTop: 50,
  },

  dialogPaper: {
    margin: 0,
    width: 400,
    height: 300,
    maxWidth: 400,
    maxHeight: 300,
    borderRadius:10
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
    alignItems: "center",
  },
  error: {
    color: theme.red,
    fontSize: 16,
  },
  button: {
    height: 69,
    minHeight: 69,
    fontSize: 26,
    margin: "0 !important",
    borderRadius: "0px 0px",
  },
  dialogAction: { padding: 0 },
}));

const ChangePasswordDialog = ({ id, open, onClose, notify }) => {
  const classes = useStyles();
  const translate = useTranslate();
  const { loading, error: loadError, changePassword } = useUsers();
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [showPassword, setShowPassword] = useState();
  const [showConfirm, setShowConfirm] = useState();
  const [error, setError] = useState();
  //   const [showPopup] = usePopup("success", ({ message, handleClose }) => (
  //     <SimplePopupDialog
  //       message={message?.message}
  //       title={message?.title}
  //       handleClose={handleClose}
  //       onConfirm={message?.onConfirm}
  //     />
  //   ));

  //   const [showAlert] = usePopup("alert", ({ message, handleClose }) => (
  //     <SimplePopupDialog
  //       message={message?.message}
  //       title={message?.title}
  //       handleClose={handleClose}
  //       error={true}
  //     />
  //   ));

  useEffect(() => {
    if (!password || !confirmPassword) return setError(" ");
    if (password !== confirmPassword) {
      return setError("Does not match");
    }
    if (password?.length < 2) {
      return setError("Password is too short");
    }
    return setError(null);
  }, [password, confirmPassword]);

  if (loading) return null;
  if (loadError) return null;

  const handleOnChangePassword = async () => {
    const [, error] = await changePassword(id, password);

    if (error) {
      alert(JSON.stringify(error));
    } else alert("Success");
    onClose();
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      classes={{ root: classes.allContainer, paper: classes.dialogPaper }}
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={onClose}
        title={"Change Password"}
      ></DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <TextField
          type={showPassword ? "text" : "password"}
          label="Password"
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Authorize code"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TextField
          type={showConfirm ? "text" : "password"}
          label="Confirm Password"
          onChange={(e) => setConfirmPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="Authorize code"
                  onClick={() => setShowConfirm(!showConfirm)}
                >
                  {showConfirm ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Typography className={classes.error}>{error}</Typography>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <Button
          color="primary"
          fullWidth
          variant="contained"
          classes={{ contained: classes.button }}
          disabled={error}
          onClick={handleOnChangePassword}
        >
          {translate("ra.action.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordDialog;
